module.exports = __webpack_public_path__ + "img/welcome-back.c356339f.png";